import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";

interface Emits {
  (e: "start-recording"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioInput',
  emits: ["start-recording"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const startRecording = () => {
  emit("start-recording");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "input-attachment",
    onClick: startRecording
  }, [
    _createVNode(Icon, {
      icon: _unref(IconType).MIC
    }, null, 8, ["icon"])
  ]))
}
}

})